// import { SearchTab } from '@habity/types';

/**
 * Build URLSearchParams from searchParams, handling:
 * - String input (from client-side useStableSearchParams)
 * - URLSearchParams input (from getQueryFromFilters)
 * - Plain object input (from server-side Next.js searchParams)
 *
 * When Next.js has multiple values for the same param (e.g., ?areaIds=1&areaIds=2),
 * it returns them as an array: { areaIds: ['1', '2'] }
 * We need to convert these to separate URLSearchParams entries to match
 * how the client-side URL string is parsed.
 */
const buildSearchParams = (searchParams: TODO): URLSearchParams => {
  // If it's already a string, parse it directly
  if (typeof searchParams === 'string') {
    return new URLSearchParams(searchParams);
  }

  // If it's already a URLSearchParams, return a copy
  // (Object.entries doesn't work on URLSearchParams, so we need this check)
  if (searchParams instanceof URLSearchParams) {
    return new URLSearchParams(searchParams);
  }

  // If it's a plain object, handle array values properly
  const params = new URLSearchParams();
  if (searchParams && typeof searchParams === 'object') {
    for (const [key, value] of Object.entries(searchParams)) {
      if (value === undefined || value === null) continue;

      if (Array.isArray(value)) {
        // Add each array item as a separate param (preserves ?key=1&key=2 format)
        for (const item of value) {
          if (item !== undefined && item !== null) {
            params.append(key, String(item));
          }
        }
      } else {
        params.append(key, String(value));
      }
    }
  }
  return params;
};

export const getQueryParamsString = ({
  searchParams,
  searchId,
  addressId,
  entityIds,
  // tab,
  authUserId,
  page,
  limit,
  includeFirstImage,
  useLimitAsTotalCount,
  showBuyerDetails,
}: {
  searchParams: TODO;
  page: string;
  // tab: SearchTab;
  searchId?: string;
  addressId?: string;
  entityIds?: string; // Comma-separated IDs of homes/brokers/buyers etc...
  authUserId?: string;
  limit?: number;
  includeFirstImage?: boolean;
  useLimitAsTotalCount?: boolean;
  showBuyerDetails?: boolean;
}) => {
  const queryParams = buildSearchParams(searchParams);
  // queryParams.append('tab', tab);
  queryParams.append('page', page);
  if (searchId) queryParams.append('searchId', searchId);
  if (addressId) queryParams.append('addressId', addressId);
  if (entityIds) queryParams.append('entityIds', entityIds);
  if (authUserId) queryParams.append('authUserId', authUserId);
  if (limit) queryParams.append('limit', limit.toString());
  if (includeFirstImage) queryParams.append('includeFirstImage', 'true');
  if (useLimitAsTotalCount)
    queryParams.append('useLimitAsTotalCount', useLimitAsTotalCount.toString());
  if (showBuyerDetails) queryParams.append('showBuyerDetails', 'true');
  queryParams.sort();
  return queryParams.toString();
};
